export const cibKibana = ["32 32","<path d='M28.052 31.984h-22.479l13.172-15.812c5.64 3.683 9.307 9.391 9.307 15.812zM28.052 0.052h-23.948v28.735z'></path>"]